import { requireAdmin } from '@/plugins/router';
import ProjectDetailsTab from '@/project/tabs/project/ProjectDetailsTab.vue';
import ProjectSeriesOverviewTab from '@/project/tabs/series/ProjectSeriesOverviewTab.vue';
import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import ProjectOverviewPage from './pages/ProjectOverviewPage.vue';
import ProjectPage from './pages/ProjectPage.vue';

import ProjectCreatePage from './pages/ProjectCreatePage.vue';
import ProjectSeriesCreatePage from './pages/ProjectSeriesCreatePage.vue';
import ProjectSeriesPage from './pages/ProjectSeriesPage.vue';
import ProjectAllocationsTab from './tabs/project/ProjectAllocationsTab.vue';
import ProjectAppointmentTab from './tabs/project/ProjectAppointmentTab.vue';
import ProjectLinksTab from './tabs/project/ProjectLinksTab.vue';
import ProjectOrgTab from './tabs/project/ProjectOrgTab.vue';
import ProjectVariantsTab from './tabs/project/ProjectVariantsTab.vue';
import ProjectSeriesAppointmentTab from './tabs/series/ProjectSeriesAppointmentTab.vue';
import ProjectSeriesDetailsTab from './tabs/series/ProjectSeriesDetailsTab.vue';
import ProjectSeriesLinksTab from './tabs/series/ProjectSeriesLinksTab.vue';
import ProjectSeriesOrgTab from './tabs/series/ProjectSeriesOrgTab.vue';

export const projectRoutes = <RouteRecordRaw[]>[
    {
        path: '/projects',
        children: [
            {
                path: '',
                name: 'projects',
                component: ProjectOverviewPage,
            },
            {
                path: 'series/add',
                name: 'project-series-add',
                beforeEnter: requireAdmin,
                component: ProjectSeriesCreatePage,
            },
            {
                path: 'add',
                name: 'project-add',
                props: (route: RouteLocationNormalized) => ({
                    seriesId: route.query.seriesId,
                    seriesName: route.query.seriesName,
                }),
                beforeEnter: requireAdmin,
                component: ProjectCreatePage,
            },
            {
                path: 'series/:seriesId',
                component: ProjectSeriesPage,
                props: true,
                children: [
                    {
                        path: '',
                        redirect: { name: 'project-series-overview-tab' },
                    },
                    {
                        path: 'overview',
                        name: 'project-series-overview-tab',
                        component: ProjectSeriesOverviewTab,
                    },
                    {
                        path: 'details',
                        name: 'project-series-details-tab',
                        component: ProjectSeriesDetailsTab,
                        props: true,
                    },
                    {
                        path: 'org',
                        name: 'project-series-org-tab',
                        component: ProjectSeriesOrgTab,
                    },
                    {
                        path: 'appointment-and-location',
                        name: 'project-series-appointment-tab',
                        component: ProjectSeriesAppointmentTab,
                    },
                    {
                        path: 'links',
                        name: 'project-series-links-tab',
                        component: ProjectSeriesLinksTab,
                    },
                ],
            },
            {
                path: 'project/:projectId',
                component: ProjectPage,
                props: true,
                children: [
                    {
                        path: '',
                        redirect: { name: 'project-details-tab' },
                    },
                    {
                        path: 'details',
                        name: 'project-details-tab',
                        component: ProjectDetailsTab,
                        props: true,
                    },
                    {
                        path: 'allocations',
                        name: 'project-overview-tab',
                        component: ProjectAllocationsTab,
                        props: true,
                    },
                    {
                        path: 'org',
                        name: 'project-org-tab',
                        component: ProjectOrgTab,
                    },
                    {
                        path: 'appointment-and-location',
                        name: 'project-appointment-tab',
                        component: ProjectAppointmentTab,
                    },
                    {
                        path: 'links',
                        name: 'project-links-tab',
                        component: ProjectLinksTab,
                    },
                    {
                        path: 'variants',
                        name: 'project-variants-tab',
                        component: ProjectVariantsTab,
                        props: true,
                    },
                ],
            },
        ],
    },
];
